import {gtmService} from '../../../../utils/gtm.service';
import {IRegisterStepperProps} from '../../brand/components/Step1';
import {Checkbox, TextField} from '@material-ui/core';
import {AiFillEye, AiOutlineEyeInvisible} from 'react-icons/ai';
import {StepperButtons} from '../../brand/components/StepperButtons';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import {IRegisterAdmin} from '../../brand/dto/IRegister';
import {AgencyService} from '../service';
import {ErrorToast, SuccessToast, WarningToast} from '../../../../utils/toasters';
import {useRecaptcha} from '../../../../shared/hooks/useRecaptcha';
import {Form} from 'react-bootstrap';
import {InternalRoutes} from '../../../../enum/InternalRoutes';
import {PasswordVerifySteps} from '../../../../shared/PasswordVerifySteps';

export const Step1 = ({stepIdNumber, handleBackStep}: IRegisterStepperProps) => {
    const {t} = useTranslation();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [currentAgency, setCurrentAgency] = useState<IRegisterAdmin>({
        email: '',
        password: '',
        isGeneralTermsAccepted: false,
        repeatPassword: '',
    });
    const {setToken, executeRecaptcha} = useRecaptcha();
    const [isTypePassword, setIsTypePassword] = useState(true);
    const [isRepeatHidden, setIsRepeatHidden] = useState(true);

    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>, isCheckbox = false) => {
        const {name, value, checked} = event.target;
        setCurrentAgency((prev) => ({
            ...prev,
            [name]: isCheckbox ? checked : value,
        }));
    };

    const handleNextStep = async () => {
        if (!executeRecaptcha) {
            return;
        }
        const result = await executeRecaptcha('register');
        setToken(result);
        if (currentAgency?.isGeneralTermsAccepted) {
            setIsLoading(true);
            AgencyService.registerAccount(currentAgency).then(response => {
                if (response) {
                    gtmService('influencer_management_lead');
                    history.push(`${InternalRoutes.AGENCY_REGISTRATION}/${stepIdNumber + 1}?token=${response?.verificationUUID}`);
                    SuccessToast(t('auth.register.brand.step1.pleaseCheckEmail'));
                }
            }).catch(error => ErrorToast(error)).finally(() => setIsLoading(false));
        } else {
            WarningToast(t('auth.register.brand.step1.termsNotSelected'));
        }
    };
    return (
        <Form className="w-100" onSubmit={(e) => {
            e.preventDefault();
            handleNextStep();
        }}>
            <div className="row">
                <div className="col-md-6">
                    <TextField
                        label="E-mail"
                        variant="outlined"
                        size="small"
                        defaultValue={currentAgency?.email ?? ''}
                        required
                        type="email"
                        name="email"
                        onChange={changeHandler}
                        className="w-100 my-2"
                    />
                </div>
                <div className="col-md-6"/>
                <div className="col-md-6">
                    <div className="d-flex align-items-center">
                        <TextField
                            label={t('auth.register.brand.step1.password')}
                            variant="outlined"
                            size="small"
                            defaultValue={currentAgency?.password ?? ''}
                            name="password"
                            required
                            onChange={changeHandler}
                            type={isTypePassword ? 'password' : 'text'}
                            className="w-100 my-2"
                        />
                        <div style={{marginLeft: '-1.8rem', zIndex: 1}} className="cursor-pointer"
                             onClick={() => setIsTypePassword(prev => !prev)}>
                            {isTypePassword ? <AiFillEye size={20}/> :
                                <AiOutlineEyeInvisible size={20}/>}
                        </div>
                    </div>
                    <PasswordVerifySteps password={currentAgency.password ?? ''}/>
                </div>
                <div className="col-md-6">
                    <div className="d-flex align-items-center">
                        <TextField
                            label={t('auth.register.brand.step1.repeatPassword')}
                            variant="outlined"
                            onChange={changeHandler}
                            type={isRepeatHidden ? 'password' : 'text'}
                            required
                            defaultValue={currentAgency?.repeatPassword ?? ''}
                            size="small"
                            name="repeatPassword"
                            className="w-100 my-2"
                        />
                        <div style={{marginLeft: '-1.8rem', zIndex: 1}} className="cursor-pointer"
                             onClick={() => setIsRepeatHidden(prev => !prev)}>
                            {isRepeatHidden ? <AiFillEye size={20}/> :
                                <AiOutlineEyeInvisible size={20}/>}
                        </div>
                    </div>
                </div>
                <div className="col-12 my-2 d-flex align-items-center">
                    <Checkbox defaultChecked={currentAgency?.isGeneralTermsAccepted ?? false} className="px-0"
                              onChange={(e) => {
                                  changeHandler(e, true);
                              }}
                              size={'small'}
                              id="checkbox"
                              name="isGeneralTermsAccepted"
                              color="primary"/>
                    <label htmlFor="checkbox" className="ml-2 mb-0 text-left cursor-pointer"
                           dangerouslySetInnerHTML={{__html: t('auth.register.brand.step1.terms')}}/>
                </div>
                <div className="col-12 mt-4">
                    <StepperButtons currentStep={stepIdNumber - 1} handleNextStep={handleNextStep} isLoading={isLoading}
                                    handleBackStep={handleBackStep}/>
                </div>
            </div>
        </Form>
    );
};
